<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">ncnn发布20220420版本，让Vulkan神经网络推理得更快</div>
      <div class="news-date">2022年5月16日</div>
      <div class="news-content">
        <p>
          <p>ncnn是腾讯开源的手机端极致优化的高性能神经网络前向计算框架。</p>
          <p><a href="https://github.com/Tencent/ncnn" target="_blank"><strong>https://github.com/Tencent/ncnn</strong></a></p>
        </p>
        <p>
          <p>Vulkan是一个低开销、跨平台的3D图形与计算的API标准。</p>
          <p><a href="https://www.vulkan.org/" target="_blank"><strong>https://www.vulkan.org/</strong></a></p>
        </p>
        <p>相较于基于cuda/cudnn的GPU加速方案，Vulkan具有更好的兼容性和可移植性，分发时二进制体积小等特点。</p>
        <div class="news-p-title">01 cuda</div>
        <p>● 仅支持 Windows/Linux</p>
        <p>● 仅支持 nvidia GPU</p>
        <p>● 运行库体积庞大，1GB+，且依赖特定的驱动版本</p>
        <div class="news-p-title">02 vulkan</div>
        <p>● 支持平台 Windows/Linux/macOS/Android/iOS</p>
        <p>● 支持 GPU intel/amd/nvidia/apple/qcom/mali</p>
        <p>● 仅依赖系统显卡驱动，无额外依赖</p>
        <p>近期，ncnn发布了20220420版本，基于Vulkan API对GPU推理做了大量优化，让神经网络在GPU推理更快。</p>
        <p>● 实现 convolution implicit gemm</p>
        <p>● 实现 deconvolution gemm+col2im</p>
        <p>● 融合 winograd transform 与 padding</p>
        <p>● 改善 winograd convolution 选择策略</p>
        <p>● 拆分 innerproduct 为两步骤提高并行度</p>
        <p>● 运用 shared memory 优化访存性能</p>
        <p>● 运用 nvidia tensorcore Vulkan扩展优化矩阵乘</p>
        <p>● 修复最新 MoltenVK 兼容性问题</p>
        <p>VapourSynth，SVP，FlowFrames，Video2x等项目集成了基于ncnn Vulkan实现的视频超分补帧功能，帮助内容创作者生成高画质的视频。更新到最新版ncnn后，不少用户发现这些AI应用ncnn版甚至比PyTorch cuda版更快了。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news11_1.png"/>
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news11_2.png"/>
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news11_3.png"/>
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news11_4.png"/>
        </div>
        <p>ncnn 20220420版本下载地址(linux/windows/macos/android/ios/webassembly，cpu+gpu)</p>
        <p><a href="https://github.com/Tencent/ncnn/releases/tag/20220420" target="_blank"><strong>https://github.com/Tencent/ncnn/releases/tag/20220420</strong></a></p>
        <div class="news-p-title">03 ncnn 20220420版本的其他更新</div>
        <p>● x86 avx512 优化</p>
        <p>● mips msa int8 优化</p>
        <p>● 新支持 Windows ARM</p>
        <p>● 新支持龙芯 LoongArch 架构</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news11_5.png"/>
          <div class="image-caption">测试平台：RTX2070，Linux x86_64</div>
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news11_6.png"/>
          <div class="image-caption">测试平台：RK3399，Android aarch64</div>
        </div>
        <p>最后，欢迎点击下方链接访问ncnn项目主页，看README加ncnn技术交流QQ群，与一线工程师和众多大佬直接交流。</p>
        <p><a href="https://github.com/Tencent/ncnn" target="_blank"><strong>https://github.com/Tencent/ncnn</strong></a></p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News11',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content-container {
  .news-content-panel .news-content{
    .image-panel {
      .news-image {
        width: 605px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News11.vue